import { render, staticRenderFns } from "./SerfQueueView.vue?vue&type=template&id=6d266204"
import script from "./SerfQueueView.vue?vue&type=script&lang=ts"
export * from "./SerfQueueView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports